import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-zinc-950 mt-20">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="block w-2.5 h-2.5 bg-white" />
            <span className="font-display text-xl">
              Versant<span className="text-zinc-500">.</span>Studio
            </span>
          </div>
          <p className="text-sm text-zinc-400 max-w-md leading-relaxed">{t("footer.tagline")}</p>
        </div>

        <div>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-zinc-500 mb-4">
            {t("footer.nav")}
          </p>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><a href="/#services" className="hover:text-white">{t("nav.services")}</a></li>
            <li><a href="/#portfolio" className="hover:text-white">{t("nav.work")}</a></li>
            <li><Link to="/simulateur" className="hover:text-white">{t("nav.simulator")}</Link></li>
            <li><a href="/#contact" className="hover:text-white">{t("nav.contact")}</a></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-zinc-500 mb-4">
            {t("footer.contact")}
          </p>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li>contact@versantstudio.fr</li>
            <li>
              <a href="tel:+33644051995" className="hover:text-white">
                +33 6 44 05 19 95
              </a>
            </li>
            <li>{t("contact.location")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-zinc-500">
          <p>© {new Date().getFullYear()} Versant Studio — {t("footer.rights")}</p>
          <p>{t("footer.france")}</p>
        </div>
      </div>
    </footer>
  );
};
